import { render, staticRenderFns } from "./view_ChickenPortuguese.vue?vue&type=template&id=fcbeb8f6&"
import script from "./view_ChickenPortuguese.vue?vue&type=script&lang=js&"
export * from "./view_ChickenPortuguese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports